export function getCookie(name: string) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function setCookie(name: string, value: boolean | string, days: number, domain = '') {
    let cName = name;
    let cDate = new Date();
    console.log(cName);
    cDate.setDate(cDate.getDate() + 1);
    const newCookie = cName + "=" + value + "; expires=" + cDate.toUTCString();
    document.cookie = newCookie;
}

export function expireCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
}